import script from "./DataGroupMemberRemoveModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataGroupMemberRemoveModal.vue?vue&type=script&setup=true&lang=ts"

import "./DataGroupMemberRemoveModal.vue?vue&type=style&index=0&id=c8f6180a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8f6180a"]])

export default __exports__